module.exports = AgoraRTC;


//////////////////
// WEBPACK FOOTER
// external "AgoraRTC"
// module id = mDny
// module chunks = 28